import React from 'react';
import StyleSheet from "react-native-web/dist/exports/StyleSheet";
import View from "react-native-web/dist/exports/View";
import PropTypes from 'prop-types';
import { useCarousel } from '../CarouselContext';
import StepTracker from '../../StepTracker';
import StackView from '../../StackView';
import Spacer from '../../Spacer';
import Progress from '../../Progress';
import { variantProp } from '../../utils';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const CarouselStepTracker = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    stepTrackerVariant,
    progressBarVariant,
    enableDisplayMultipleItemsPerSlide
  } = _ref;
  const {
    activeIndex,
    totalItems,
    getCopyWithPlaceholders,
    themeTokens: {
      stepTrackerCurrentBackgroundColor,
      ...themeTokens
    }
  } = useCarousel();
  const stackViewTokens = {
    justifyContent: 'center'
  };
  const stepTrackerTokens = {
    showStepLabel: false,
    showStepTrackerLabel: true,
    // TODO: StepTracker 'isComplete'/'isCurrent' is incorrect, see line StepTracker/Step.jsx line 63, refactor incorrect values and remove this
    knobCompletedBackgroundColor: stepTrackerCurrentBackgroundColor ?? 'none',
    connectorCompletedColor: 'none',
    connectorColor: 'none',
    containerPaddingTop: themeTokens.spaceBetweenSlideAndPanelNavigation
  };
  const steps = Array.from(Array(totalItems)).map((_, index) => String(index));
  const showProgressBar = enableDisplayMultipleItemsPerSlide && progressBarVariant?.style !== 'dots';
  if (showProgressBar) {
    if (totalItems === 1) {
      return null;
    }
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        space: 4
      }), /*#__PURE__*/_jsx(StackView, {
        direction: "row",
        tokens: stackViewTokens,
        ref: ref,
        children: /*#__PURE__*/_jsx(View, {
          style: staticStyles.progress,
          children: /*#__PURE__*/_jsx(Progress, {
            children: /*#__PURE__*/_jsx(Progress.Bar, {
              offset: {
                items: totalItems,
                current: activeIndex + 1
              },
              variant: progressBarVariant,
              accessibilityLabel: getCopyWithPlaceholders('stepTrackerLabel')
            })
          })
        })
      })]
    });
  }
  if (enableDisplayMultipleItemsPerSlide && totalItems === 1) {
    return null;
  }
  return /*#__PURE__*/_jsx(StackView, {
    direction: "row",
    tokens: stackViewTokens,
    ref: ref,
    children: /*#__PURE__*/_jsx(StepTracker, {
      current: activeIndex,
      steps: steps,
      copy: {
        stepLabel: getCopyWithPlaceholders('stepLabel'),
        stepTrackerLabel: enableDisplayMultipleItemsPerSlide ? '' : getCopyWithPlaceholders('stepTrackerLabel')
      },
      tokens: stepTrackerTokens,
      variant: stepTrackerVariant
    })
  });
});
CarouselStepTracker.displayName = 'CarouselStepTracker';
CarouselStepTracker.propTypes = {
  stepTrackerVariant: variantProp.propType,
  progressBarVariant: variantProp.propType,
  enableDisplayMultipleItemsPerSlide: PropTypes.bool
};
const staticStyles = StyleSheet.create({
  progress: {
    width: 288
  }
});
export default CarouselStepTracker;